import { createSlice } from '@reduxjs/toolkit';
import { getSummaryAction } from 'redux/action/summaryAction';
import { toastText } from 'utils/utils';

const initialState: any = {
    summary: [],
    grandTotal: 0,
    pagination: {
        currentPage: 1,
        totalPages: 0,
        totalGroups: 0,
        limit: 50,
    },
    isLoading: false,
    isLoadingMore: false,
    hasMore: true,
    error: null,
    fistTimeFetchLoading: true,
    sortConfig: {
        sortBy: 'totalAmount',
        sortOrder: 'desc',
    },
    filters: {
        fromDate: null,
        toDate: null,
        accountIds: [],
        customerIds: [],
        classIds: [],
        locationIds: [],
    },
};

const SummarySlice = createSlice({
    name: 'summary',
    initialState,
    reducers: {
        clearRedux: () => {
            return {
                ...initialState,
            };
        },
        updateLoadingHandler: (state) => {
            state.isLoading = false;
        },
        updateSortConfig: (state, action) => {
            state.sortConfig = action.payload;
        },
        updateFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        clearFilters: (state) => {
            state.filters = {
                fromDate: null,
                toDate: null,
                accountIds: [],
                customerIds: [],
                classIds: [],
                locationIds: [],
            };
        },
        resetSummary: (state) => {
            state.summary = [];
            state.grandTotal = 0;
            state.pagination.currentPage = 1;
            state.hasMore = true;
        },
    },
    extraReducers: (builder) => {
        // Get Summary
        builder.addCase(getSummaryAction.pending, (state, action) => {
            const page = action.meta.arg.page || 1;
            if (page === 1) {
                // First page - initial load
                state.fistTimeFetchLoading = true;
                state.isLoading = true;
            } else {
                // Subsequent pages - infinite scroll
                state.isLoadingMore = true;
            }
            state.error = null;
        });
        builder.addCase(getSummaryAction.fulfilled, (state, action) => {
            const page = action.meta.arg.page || 1;
            if (page === 1) {
                // First page - replace all summary groups
                state.summary = action.payload.summary;
                state.grandTotal = action.payload.grandTotal;
                state.fistTimeFetchLoading = false;
                state.isLoading = false;
            } else {
                // Subsequent pages - append to existing summary groups
                state.summary = [...state.summary, ...action.payload.summary];
                state.isLoadingMore = false;
            }
            state.pagination = action.payload.pagination;
            state.hasMore = action.payload.pagination.currentPage < action.payload.pagination.totalPages;
        });
        builder.addCase(getSummaryAction.rejected, (state, action: any) => {
            state.error = action.payload;
            state.fistTimeFetchLoading = false;
            state.isLoading = false;
            state.isLoadingMore = false;
            toastText(action.payload?.message || 'Failed to fetch summary data', 'error');
        });
    },
});

export default SummarySlice;
export const {
    clearRedux,
    updateLoadingHandler,
    updateSortConfig,
    updateFilters,
    clearFilters,
    resetSummary
} = SummarySlice.actions;
